import { render } from "./ViewImo1Component.vue?vue&type=template&id=48a40623"
import script from "./ViewImo1Component.vue?vue&type=script&lang=js"
export * from "./ViewImo1Component.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__